import React from "react";
import PropTypes from "prop-types";

import CheckoutFormPurchaseButton from "./CheckoutFormPurchaseButton";

import {
    CancelLink,
    CheckoutFormButtonsContainer,
    PurchaseButtonContainer,
    CancelLinkContainer
} from "./styles";

const CheckoutPathFormButtons = ({
    purchaseButtonOnClick,
    showPayPalButton,
    isProcessing,
    isDisabled,
    cancelLink,
    licenseSelection
}) => {
    return (
        <CheckoutFormButtonsContainer>
            <PurchaseButtonContainer>
                <CheckoutFormPurchaseButton
                    onClick={purchaseButtonOnClick}
                    showPayPalButton={showPayPalButton}
                    isProcessing={isProcessing}
                    isDisabled={isDisabled}
                    licenseSelection={licenseSelection}
                >
                    Purchase
                </CheckoutFormPurchaseButton>
            </PurchaseButtonContainer>

            <CancelLinkContainer>
                <CancelLink to={cancelLink}>Cancel</CancelLink>
            </CancelLinkContainer>
        </CheckoutFormButtonsContainer>
    );
};

CheckoutPathFormButtons.propTypes = {
    purchaseButtonOnClick: PropTypes.func.isRequired,
    showPayPalButton: PropTypes.bool,
    isProcessing: PropTypes.bool,
    isDisabled: PropTypes.bool,
    cancelLink: PropTypes.string.isRequired,
    licenseSelection: PropTypes.string.isRequired
};

export default CheckoutPathFormButtons;
